import { CAPITAL, SUBSCRIPTION_MODULE_TYPE, SUBSCRIPTION_MODULE_TYPE_NAME, SUPPORTED_PAYMENT_METHOD_LIST } from "../constants";
import capitalService from "../services/capital.service";
import { manualPaymentAction, paymentModalAction } from "./stripe";

import {
  GET_CAPITAL_LIST,
  SET_SUCCESS_MESSAGE,
  SET_FAILED_MESSAGE,
  LOAD_CAPITAL_SKELETON,
  SELECTED_SUSBCRIPTION_PLAN_PRODUCTS,
  SET_BANK_CRYPTO_DETAILS,
  ADD_CAPITAL,
} from "./types";
export const getCapitalList = (companyId) => async (dispatch) => {
  dispatch({ type: LOAD_CAPITAL_SKELETON, payload: false })
  return capitalService.getCapital(companyId).then(async (resp) => {
    if (resp.status) {
      await dispatch({ type: GET_CAPITAL_LIST, payload: resp });
      return resp
    } else {
      dispatch({ type: LOAD_CAPITAL_SKELETON, payload: false })
    }
  });
};

export const addCapital = (payload) => async (dispatch) => {
  return capitalService.addCapital(payload).then((resp) => {
    if (resp.status) {
      if (payload?.capitalType === CAPITAL.paidUp) {
        dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.data, });
      }
      dispatch({ type: ADD_CAPITAL, payload: payload, });
      dispatch(getCapitalList(payload.company));
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    return Promise.resolve();
  });
};



export const getPaidUpById = (paidupId, selectedPlanPage, modalEnable = false, paidUpAmountPaid) => async (dispatch, getState) => {
  return capitalService.getSinglePaidUp(paidupId).then((resp) => {
    if (resp.status) {
      const paidAmountResp = paidUpAmountPaid?.find(x => x.currency.toLowerCase() === resp?.data?.currency?.toLowerCase() && parseInt(x.shareType) === resp?.data?.shareType)
      const priceAmount = (paidAmountResp && Object.keys(paidAmountResp).length > 0) ? (parseFloat(resp?.data?.shareCapital) - parseFloat(paidAmountResp?.paidAmount)).toFixed(2) : resp?.data?.shareCapital
      const { defaultStripePriceId } = getState()?.settings?.settings
      const payloadResp = {
        name: modalEnable ? "Deposit Paid-Up Capital for Share Ownership" : "Paid-up capital",
        smallDescription: "Deposit Paid-Up Capital",
        shortDescription: "Deposit capital into your Singapore company and receive share ownership.",
        targetAudience: modalEnable ? `<p>Empower your company with essential funding by depositing paid-up capital, securing your stake as a shareholder. 
      When you deposit capital, it strengthens your company’s financial foundation and formalizes your ownership, positioning you to drive growth and operations effectively.
       With your capital deposit, you’ll receive:</p>
       <ul class='mt-3'>
       <li>Official Share Issuance confirming your ownership stake.</li>
       </ul>
       <p>This service exclusively facilitates your capital deposit and share issuance. For further support, such as company governance, compliance, or advisory, explore our company plans. With your capital deposit, you’ll be eligible for a discount on any of these plans, helping you build your business with robust resources.</p>` :
          `You are depositing paid-up capital to ${getState()?.company?.selectedCompany?.companyName} in return for share ownership in the named company.`,
        planType: {
          value: SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL,
          name: SUBSCRIPTION_MODULE_TYPE_NAME[SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL]
        },
        isActive: true,
        baseRequestCurrency: resp?.data?.currency?.toLowerCase() || null,
        currency: { "value": resp?.data?.currency?.toLowerCase(), "label": resp?.data?.currency?.toUpperCase() },
        price: (parseFloat(priceAmount) > 0 ? priceAmount : 0) || 0,
        stripePriceId: defaultStripePriceId ? defaultStripePriceId[resp?.data?.currency?.toLowerCase()] : null || null,
        supportedPaymentMethod: SUPPORTED_PAYMENT_METHOD_LIST || [],
        capital: resp?.data,
        image: "../assets/img/paid-up_image.png",
        guarentedFeature: ["Legal recognition affirming your capital deposit and ownership stake in the company."],
        assuredFeature: ["Share Ownership in the form of officially recognized ownership of ordinary or preference shares, confirming your contribution and shareholder status."]
      }
      dispatch({
        type: SELECTED_SUSBCRIPTION_PLAN_PRODUCTS,
        payload: payloadResp,
        currentPage: selectedPlanPage?.page,
        activeSegment: selectedPlanPage?.activeSegment,
        activePaidUpIndex: selectedPlanPage?.activePaidUpIndex || 0,
      });
      dispatch(manualPaymentAction(payloadResp?.price))
      dispatch(paymentModalAction(false, SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL));
    } else {
      dispatch({
        type: SELECTED_SUSBCRIPTION_PLAN_PRODUCTS,
        payload: null,
        currentPage: selectedPlanPage?.page,
        activeSegment: selectedPlanPage?.activeSegment,
        activePaidUpIndex: selectedPlanPage?.activePaidUpIndex || 0,
      });
    }
    // dispatch({ type: SET_BANK_CRYPTO_DETAILS, payload: null });
    return resp;
  });
};

export const getCapitalLisSingle = (companyId) => {
  return capitalService.getCapital(companyId).then((resp) => {
    if (resp.status) {
      return resp
    }
  });
};